import { IContractorPayment } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export const triggerContractorPayment = (axios: IAxiosInstance) => {
  return async (params: { companyID: string; contractorPaymentID: string }) => {
    const response = await axios.noRetry.post<IApiResponse<IContractorPayment>>(
      "contractorPayment/trigger",
      {
        companyID: params.companyID,
        contractorPaymentID: params.contractorPaymentID,
      }
    );

    return response.data;
  };
};
